<div
  #breadcrumbsCell
  class="sol-topbar-left"
  [class.sol-topbar-left-collapsed]="collapsed$()"
  role="navigation"
  aria-label="Breadcrumb"
>
  @if (breadcrumbsLoading$()) {
    <sol-loader [loader]="SolLoader.ofBlocks(1, 1, '32').withMargin('0')" style="width: 256px" />
  } @else {
    @if (navbarHidden$()) {
      <sol-button [icon]="SolIcon.menu" [type]="SolButtonType.transparent" (click)="onNavbarOpen()" />
    }

    @if (backBreadcrumb$(); as back) {
      <sol-tooltip class="sol-topbar-back" [tooltip]="backTooltip">
        <sol-button [icon]="SolIcon.arrow_left" [type]="SolButtonType.transparent" (click)="onBreadcrumbClick(back)" />
      </sol-tooltip>
    }

    @if (collapsed$()) {
      <sol-button
        class="sol-topbar-collapse-button"
        [icon]="SolIcon.menu_horizontal"
        [type]="collapsedOpen$() ? SolButtonType.secondary : SolButtonType.transparent"
        (click)="onToggleCollapsed()"
      />
      <span class="sol-topbar-divider">/</span>
    }

    <div
      class="sol-topbar-trail"
      [class.sol-topbar-trail-popover]="collapsed$()"
      [class.sol-topbar-trail-popover-open]="collapsedOpen$()"
    >
      @if (customBreadcrumbs$()) {
        <ng-content select="[slot=breadcrumbs]" />
      }
      @for (breadcrumb of leadingBreadcrumbs$(); track breadcrumb.id) {
        <div
          class="sol-topbar-left-title"
          [class.sol-topbar-left-title-clickable]="breadcrumb.clickable"
          (click)="onBreadcrumbClick(breadcrumb)"
        >
          @if (breadcrumb.icon !== undefined) {
            <sol-icon [name]="breadcrumb.icon!" />
          }
          <sol-tooltip [tooltip]="breadcrumbTooltips$()[breadcrumb.id]">
            <span class="sol-topbar-left-title-text">{{ breadcrumb.name | translate }}</span>
          </sol-tooltip>
        </div>
        <span class="sol-topbar-divider">/</span>
      }
    </div>

    @if (hasTemplateLeaf$()) {
      <div class="sol-topbar-leaf" [class.sol-topbar-leaf-collapsed]="collapsed$()">
        <ng-container *ngTemplateOutlet="breadcrumbsTemplate$()!" />
      </div>
    } @else if (leafBreadcrumb$(); as leaf) {
      <div
        class="sol-topbar-left-title sol-topbar-left-title-last"
        [class.sol-topbar-left-title-leaf]="collapsed$()"
        [class.sol-topbar-left-title-clickable]="leaf.clickable"
        (click)="onBreadcrumbClick(leaf)"
      >
        @if (leaf.icon !== undefined) {
          <sol-icon [name]="leaf.icon!" />
        }
        <sol-tooltip [tooltip]="breadcrumbTooltips$()[leaf.id]">
          <span class="sol-topbar-left-title-text">{{ leaf.name | translate }}</span>
        </sol-tooltip>
      </div>
    }
  }
</div>
<div class="sol-topbar-center">
  @if (!loading$() && tabs$().length > 0) {
    <sol-tabs
      [tabs]="tabs$()"
      [selectedTab]="selectedTab$()"
      (selectedTab)="onSelectedTab($event)"
      [dividerVisible]="false"
      [large]="true"
    />
  }
</div>
<div class="sol-topbar-right">
  <div class="sol-detail-header-actions">
    @if (loading$()) {
      <sol-loader [loader]="SolLoader.ofBlocks(1, 1, '32').withMargin('0')" style="width: 256px" />
    } @else {
      <ng-content select="[slot=actions]" />
      @if (toolbarTemplate$()) {
        <ng-container *ngTemplateOutlet="toolbarTemplate$()!" />
      }
      @for (action of promotedActions$(); track action.id) {
        <sol-button
          [icon]="action.icon"
          [type]="action.type || SolButtonType.transparent"
          [text]="action.name || ''"
          [disabled]="action.disabled || false"
          (click)="onAction(action.id)"
        />
      }
      @if (hasContextMenu$()) {
        <sol-button [icon]="SolIcon.menu_vertical" [type]="SolButtonType.transparent" (click)="showMenu($event)" />
      }
    }
  </div>
</div>
